module.exports = __webpack_public_path__ + "img/no-test-report.55e8a676.png";